import CONFIG from '../Config/index'
import {create} from 'apisauce'
import languageStore from '../../lang';

export class Backend {
  constructor (authData) {
    const headers = {
      Accept: 'application/json',
    };

    if (CONFIG.backend.clientId) {
      headers['X-Tenant-ClientID'] = CONFIG.backend.clientId;
    }

    if (authData && authData.access_token) {
      headers.Authorization = `Bearer ${authData.access_token}`
    }

    this.api = create({
      baseURL: CONFIG.backend.url,
      headers
    });

        // if (DebugConfig.enableReactotron) {
        //     this.api.addMonitor(Reactotron.apisauce);
        // }
  }

  get (path, params, headers) {

    if (!params) params = {};

    params._lang = languageStore.lang;

    return this.api.get(path, params, {headers: headers || {}})
  }

  post (path, data, headers) {
    if (!data) data = {};

    data._lang = languageStore.lang;

    return this.api.post(path, data, {headers: headers || {}})
  }

  postForm (path, data, headers = {}) {
    if (!data) data = {};
    
    data._lang = languageStore.lang;

    const formBody = []
    for (const property in data) {
      if (Object.prototype.hasOwnProperty.call(data, property)) {
        const encodedValue = data[property]
        formBody.push(`${property}=${encodedValue}`)
      }
    }
    const formString = formBody.join('&')
    headers['Content-Type'] = 'application/x-www-form-urlencoded'

    return this.post(path, formString, headers)
  }
}

export default Backend



// WEBPACK FOOTER //
// ./src/App/Services/Backend.js